import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSourceOrganizations = createSelector(
  [(store: RootState) => store.users.sourceOrganizations ?? []],
  (data) => data
);
